import { render } from "./galaxyComponent.vue?vue&type=template&id=fc6083ae"
import script from "./galaxyComponent.vue?vue&type=script&lang=js"
export * from "./galaxyComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__